import { combineReducers } from 'redux';

import loadState, * as loadStateSelectors from './loadState';
import listingsSummary from './listingsSummary';
import collectionFilter, {
  getCategories,
  getCollection,
} from './collectionFilter';
import furnitureFilter, {
  getFurnitureFilter as getFurniture,
} from './furnitureFilter';
import billsFilter, { getBillsFilter as getBills } from './billsFilter';
import roomsFilter, { getRoomsFilter as getRooms } from './roomsFilter';
import genderFilter, { getGenderFilter as getGender } from './genderFilter';
import registrationFilter, {
  getRegistrationFilter as getRegistration,
} from './registrationFilter';
import suitableForFilter, {
  getSuitableForFilter as getSuitableFor,
} from './suitableForFilter';
import recentlyAddedFilter, {
  getRecentlyAddedFilter as getRecentlyAdded,
} from './recentlyAddedFilter';
import rulesFilter, { getRulesFilter as getRules } from './rulesFilter';
import listings from './listings';
import map from './map';
import pageInfo from './pageInfo';
import priceFilter from './priceFilter';
import dateFilter from './dateFilter';
import universities from './universities';
import citiesNearby from './citiesNearby';
import currencyRates from './currencyRates';
import langURLList from './langURLList';
import searchAlert, {
  getIsLoading as isLoadingSearchAlert,
  getIsError as isErrorSearchAlert,
  getCurrentSearchAlert as currentSearchAlert,
} from './searchAlert';
import requestCache from './requestCache';
import filterPreview, {
  getPreviewNumberOfListings as getPreviewNumberOfListingsSelector,
  getPreviewRequestId as getPreviewRequestIdSelector,
} from './filterPreview';
import suggestionBar, { isVisible } from './suggestionBar';

export default combineReducers({
  loadState,
  collectionFilter,
  furnitureFilter,
  billsFilter,
  roomsFilter,
  registrationFilter,
  suitableForFilter,
  recentlyAddedFilter,
  rulesFilter,
  genderFilter,
  listings,
  listingsSummary,
  map,
  pageInfo,
  dateFilter,
  priceFilter,
  universities,
  citiesNearby,
  langURLList,
  currencyRates,
  searchAlert,
  requestCache,
  filterPreview,
  suggestionBar,
});

export const getCountryCode = state =>
  loadStateSelectors.getCountryCode(state.loadState);

export const getFurnitureFilter = state => getFurniture(state.furnitureFilter);
export const getBillsFilter = state => getBills(state.billsFilter);
export const getRoomsFilter = state => getRooms(state.roomsFilter);
export const getGenderFilter = state => getGender(state.genderFilter);
export const getCategoriesFilter = state =>
  getCategories(state.collectionFilter);
export const getCollectionFilter = state =>
  getCollection(state.collectionFilter);
export const getRegistrationFilter = state =>
  getRegistration(state.registrationFilter);
export const getRulesFilter = state => getRules(state.rulesFilter);
export const getSuitableForFilter = state =>
  getSuitableFor(state.suitableForFilter);
export const getRecentlyAddedFilter = state =>
  getRecentlyAdded(state.recentlyAddedFilter);
export const getPreviewNumberOfListings = state =>
  getPreviewNumberOfListingsSelector(state.filterPreview);
export const getPreviewRequestId = state =>
  getPreviewRequestIdSelector(state.filterPreview);
export const getIsLoadingSearchAlert = state =>
  isLoadingSearchAlert(state.searchAlert);
export const getIsErrorSearchAlert = state =>
  isErrorSearchAlert(state.searchAlert);
export const getCurrentSearchAlert = state =>
  currentSearchAlert(state.searchAlert);
export const isSuggestionBarVisible = state => isVisible(state.suggestionBar);
